module.exports = __webpack_public_path__ + "static/media/bushfire-front.73cd6b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/bushfire-front.png
// module id = 57
// module chunks = 0